import React, { useState, useEffect } from "react";
import httpService from "../../../services/httpServices/httpServices";
import validateFormInfoUser from "../../../validtions/forms/user-info";
import helperSpinner from "../../../helpers/spinner";
import helperNumbers from "../../../helpers/numbers";

function MobileUser(props) {
  const [init, setInit] = useState(false);
  const [mobile, setMobile] = useState(props.mobile);
  const [mobileUserConfirm, setMobileUserConfirm] = useState(false);
  const [editMobile, setEditMobile] = useState(false);
  const [sendConfirmCodeMobile, setSendConfirmCodeMobile] = useState(false);
  const [checkExistMobileUser, setCheckExistMobileUser] = useState(false);
  const [messageMobile, setMessageMobile] = useState();
  let messageMobileTag;
  if (messageMobile) {
    messageMobileTag = (
      <div className={`${messageMobile.type_class}`}>
        <i className={`${messageMobile.class_icon} pl-2`}></i>
        <span>{messageMobile.text}</span>
      </div>
    );
  }

  useEffect(() => {
    checkExistUserMobile().then(() => {
      checkMobileUserConfirm().then(() => {
        setInit(true);
      });
    });
  }, []);

  const checkMobileUserConfirm = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    setMobileUserConfirm(await sendRequestCheckMobileUserConfirm());
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const sendRequestCheckMobileUserConfirm = async () => {
    const headersRequest = getHeaderRequest();
    let result;
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/auth/check-mobile-confirm",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return result.data.data;
  };

  const checkExistUserMobile = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultCheckExistUserMobile = await sendRequestCheckExistUserMobile();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    setCheckExistMobileUser(resultCheckExistUserMobile);
    return resultCheckExistUserMobile;
  };

  const sendRequestCheckExistUserMobile = async () => {
    const headersRequest = getHeaderRequest();
    let result;
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/auth/check-exist-user-mobile",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return result.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendSmsCodeVerificationMobile = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestSmsCodeVerificationMobile =
      await sendRequestSmsCodeVerificationMobile();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestSmsCodeVerificationMobile) {
      return;
    }
    setSendConfirmCodeMobile(true);
  };

  const confirmMobile = async (e) => {
    e.preventDefault();
    const confirmCodeMobile = document.querySelector(
      "#confirm-code-mobile"
    ).value;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    const resultConfirmMobile = await sendRequestConfirmMobile(
      confirmCodeMobile
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (resultConfirmMobile != true) {
      setMessageMobile({
        type_class: "alert alert-danger ",
        text: resultConfirmMobile.data.message,
        class_icon: "fa fa-exclamation-triangle pl-2 ",
      });
      return;
    }
    setMobileUserConfirm(true);
  };

  const registerMobileUser = async (e) => {
    e.preventDefault();
    const resultValidation = validateFormInfoUser.validateMobile(mobile);
    if (resultValidation != true) {
      setMessageMobile({
        type_class: "alert alert-danger ",
        text: resultValidation,
        class_icon: "fa fa-exclamation-triangle pl-2 ",
      });
      return;
    }
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestRegisterMobileUser =
      await sendRequestRegisterMobileUser(mobile);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestRegisterMobileUser) {
      return;
    }
    setCheckExistMobileUser(true);
    await sendSmsCodeVerificationMobile();
  };

  const sendRequestRegisterMobileUser = async (mobile) => {
    const headersRequest = getHeaderRequest();
    let result;
    try {
      result = await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/auth/register-mobile-user",
        {
          mobile: mobile,
        },
        headersRequest
      );
    } catch (error) {
      setMessageMobile({
        type_class: "alert alert-danger ",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle pl-2 ",
      });
      return false;
    }

    return result.data.data;
  };

  const sendRequestSmsCodeVerificationMobile = async () => {
    const headersRequest = getHeaderRequest();
    let queryString = "";
    if (mobile != null) {
      queryString = `?mobile=${mobile}`;
    }
    try {
      await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/auth/send-sms-code-verification-mobile" +
          queryString,
        headersRequest
      );
    } catch (error) {
      return false;
    }

    return true;
  };

  const sendRequestConfirmMobile = async (confirmCodeMobile) => {
    let result;
    const headersRequest = getHeaderRequest();
    const bodyRequest = {
      mobile: mobile,
      confirm_code: confirmCodeMobile,
    };
    try {
      result = await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/auth/confirm-mobile",
        bodyRequest,
        headersRequest
      );
    } catch (error) {
      return error.response;
    }

    return result.data.success;
  };

  const checkStatusMobileUser = () => {
    return checkExistMobileUser == true ? (
      <>
        {mobileUserConfirm == true ? (
          <div className="pt-3 d-flex align-items-center justify-content-between">
            {editMobile == true ? (
              <div className="d-flex align-items-center justify-content-between">
                <span>
                  <p className="m-0">شماره همراه شما تایید شد.</p>
                </span>
              </div>
            ) : (
              <div className="d-flex align-items-center justify-content-between">
                <span>
                  <p className="m-0">شماره همراه شما از قبل تایید شده است.</p>
                </span>
              </div>
            )}
            <span>
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  setEditMobile(true);
                  setMobileUserConfirm(false);
                  setCheckExistMobileUser(false);
                  setSendConfirmCodeMobile(false);
                }}
              >
                ویرایش شماره موبایل
              </button>
            </span>
          </div>
        ) : (
          <>
            {sendConfirmCodeMobile == true ? (
              <>
                <div className="pt-3">
                  <p className="m-0">
                    لطفا کد ارسال شده به شماره همراه خود را وارد کرده و روی دکمه
                    تایید کد کلیک نمائید.
                  </p>
                </div>
                <div>
                  <form className="pt-3 d-flex justify-content-center">
                    <span className="pl-2">
                      <input
                        className="form-control"
                        id="confirm-code-mobile"
                        placeholder="کد تایید"
                      />
                    </span>
                    <span>
                      <button
                        className="btn btn-success"
                        onClick={confirmMobile}
                      >
                        تایید کد
                      </button>
                    </span>
                  </form>
                </div>{" "}
              </>
            ) : (
              <>
                <div className="pt-3">
                  <p className="m-0">
                    جهت تایید شماره همراه خود روی دکمه زیر کلیک نمائید.
                  </p>
                </div>
                <div className="pt-3 text-center">
                  <span className="pl-1">
                    <button
                      className="btn btn-success"
                      onClick={sendSmsCodeVerificationMobile}
                    >
                      ارسال کد تایید
                    </button>
                  </span>
                  <span className="pr-1">
                    <button
                      className="btn btn-primary"
                      onClick={(e) => {
                        e.preventDefault();
                        setMobileUserConfirm(false);
                        setSendConfirmCodeMobile(false);
                        setCheckExistMobileUser(false);
                        setEditMobile(true);
                      }}
                    >
                      ویرایش شماره موبایل
                    </button>
                  </span>
                </div>
              </>
            )}
          </>
        )}
      </>
    ) : (
      <>
        <>
          {mobileUserConfirm == true ? (
            <div className="pt-3 d-flex align-items-center justify-content-between">
              <span>
                <p className="m-0">شماره همراه شما از قبل تایید شد.</p>
              </span>
              <span>
                <button
                  className="btn btn-primary"
                  onClick={(e) => {
                    e.preventDefault();
                    setMobileUserConfirm(false);
                    setSendConfirmCodeMobile(false);
                    setCheckExistMobileUser(false);
                    setEditMobile(true);
                  }}
                >
                  ویرایش شماره موبایل
                </button>
              </span>
            </div>
          ) : (
            <>
              <div className="pt-3">
                <p className="m-0">
                  لطفا شماره همراه خود را وارد کرده و روی دکمه ارسال کد تایید
                  کلیک نمائید.
                </p>
              </div>
              <div>
                <form className="pt-3 d-flex justify-content-center">
                  <span className="pl-2">
                    <input
                      className="form-control"
                      id="mobile"
                      placeholder="۰۹۱۲..."
                      onChange={(e) => {
                        setMobile(e.target.value);
                      }}
                    />
                  </span>
                  <span>
                    <button
                      className="btn btn-success"
                      onClick={registerMobileUser}
                    >
                      ارسال کد تایید
                    </button>
                  </span>
                </form>
              </div>
            </>
          )}
        </>
      </>
    );
  };

  return (
    <>
      {/* <section className="content-header pt-4  pb-0">
        <div className="container-fluid-fluid">
          <div className="row">
            <div className="w-100 text-center">
              <h1 className="px-5 py-1  bg-warning">تایید شماره همراه</h1>
            </div>
          </div>
        </div>
      </section> */}
      <section className="content">
        <div className="card">
          <div className="card-body d-flex flex-column">
            {messageMobileTag}
            {mobileUserConfirm == false ? (
              <div className="alert alert-warning ">
                <i className="fa fa-exclamation-triangle pl-2"></i>
                <span>
                  شما هنوز شماره همراه خود را تایید نکرده اید.لطفا شماره همراه
                  خود را تایید کنید.
                </span>
              </div>
            ) : (
              <></>
            )}
            <div className="d-flex flex-row">
              <div className="pl-2">
                <span>
                  {checkExistMobileUser == false ? (
                    <i className="fas fa-times-circle text-warning"></i>
                  ) : (
                    <>
                      {mobileUserConfirm == true ? (
                        <i className="fas fa-check-circle text-success"></i>
                      ) : (
                        <i className="fas fa-times-circle text-warning"></i>
                      )}
                    </>
                  )}
                </span>
              </div>
              <div>
                <div>
                  <p className="m-0">
                    <span>کاربر محترم</span>
                    {"      "}
                  </p>
                </div>
                <div className="pt-3">
                  <span>شماره همراه : </span>
                  <span dir="ltr">
                    {mobile != undefined
                      ? helperNumbers.toPersianNum(
                          helperNumbers.presentMobileNumber(mobile)
                        )
                      : ""}
                  </span>
                </div>
                {init == true ? checkStatusMobileUser() : <></>}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default MobileUser;
